import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DepositTranslatePipe } from '@fitness-force/pipes/common-pipes';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'deposit-name',
  templateUrl: './deposit-name.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, DepositTranslatePipe, AsyncPipe],
})
export class DepositNameComponent implements OnInit {
  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);
  constructor() {}

  ngOnInit(): void {}
}
